import React from 'react';

import DataGrid, { Column, FilterRow, Summary, TotalItem } from 'devextreme-react/data-grid';

import { AppCard } from 'components/appComponents';

import { useGetDriverSalaryDetailsQuery } from 'bus/comingNomenclatureMain/services/main';

type Props = {
  dateBegin: string;
  dateEnd: string;
  id: string | number;
};

const ConsumptionNomenclatureSalaryInfo = React.forwardRef<any, Props>(({ dateBegin, dateEnd, id }, ref) => {
  const { data } = useGetDriverSalaryDetailsQuery({
    driverId: +id,
    dateBegin: String(dateBegin),
    dateEnd: String(dateEnd),
  });
  return (
    <div className="container-dev">
      <AppCard>
        <DataGrid
          dataSource={data?.data || []}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          key="id"
          ref={ref}
          onRowPrepared={(e) => {
            //@ts-ignore
            if (e.rowType === 'data' && e.data.isColoredRow) {
              //@ts-ignore
              e.rowElement.style.backgroundColor = '#ffbe85';
            }
          }}
        >
          <FilterRow visible={true} />
          <Column dataField="date" caption="Дата" dataType="date" sortOrder="asc" width={190} />
          <Column dataField="objectName" caption="Объект" />
          <Column dataField="factoryName" caption="Завод" />
          <Column dataField="transport" caption="Транспорт" />
          <Column dataField="nomenclature" caption="Материал" />
          <Column dataField="count" caption="Кол" />
          <Column dataField="quantity" caption="Объем" />
          <Column dataField="price" caption="Ставка" />
          <Column dataField="overRate" caption="Коэффициент" />
          <Column dataField="toPay" caption="К оплате, руб" />
          <Column dataField="adjustments" caption="Корректировка" />
          <Column dataField="cashFlow" caption="Касса" />

          <Summary>
            <TotalItem column="price" summaryType="sum" displayFormat="Итого: {0}" />
            <TotalItem column="toPay" summaryType="sum" displayFormat="Итого: {0}" />
            <TotalItem column="adjustments" summaryType="sum" displayFormat="Итого: {0}" />
            <TotalItem column="cashFlow" summaryType="sum" displayFormat="Итого: {0}" />
          </Summary>
        </DataGrid>
      </AppCard>
    </div>
  );
});

export default ConsumptionNomenclatureSalaryInfo;
